import type { Address } from 'src/graphql';

export interface AddressLine {
  id: string;
  text: string;
}

/**
 * The address broken into display lines: business name, street, then city/state/zip.
 * Falls back to `fullAddress` when none of the parts are set.
 */
export function getAddressTooltipLines(address: Address): AddressLine[] {
  const businessName = address.businessName?.trim();
  const address1 = address.address1?.trim();
  const address2 = address.address2?.trim();
  const city = address.city?.trim();
  const state = address.state?.trim();
  const zip = address.zip?.trim();

  const raw: string[] = [];
  if (businessName) raw.push(businessName);
  if (address1 || address2) raw.push([address1, address2].filter(Boolean).join(' '));
  if (city || state || zip) {
    const cityState = [city, [state, zip].filter(Boolean).join(' ')]
      .filter(Boolean)
      .join(', ');
    if (cityState) raw.push(cityState);
  }
  if (raw.length === 0 && address?.fullAddress?.trim()) {
    raw.push(address.fullAddress.trim());
  }
  return raw.map((text, i) => ({ id: `address-line-${i}`, text }));
}
